import { render } from "./ChatbotFlotante.vue?vue&type=template&id=2033e2a4&scoped=true"
import script from "./ChatbotFlotante.vue?vue&type=script&lang=js"
export * from "./ChatbotFlotante.vue?vue&type=script&lang=js"

import "./ChatbotFlotante.vue?vue&type=style&index=0&id=2033e2a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2033e2a4"]])

export default __exports__